import { render } from "./MovieSection.vue?vue&type=template&id=954953a4"
const script = {}

import "./MovieSection.vue?vue&type=style&index=0&id=954953a4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__